import { provideZoneChangeDetection } from '@angular/core';
/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { loadPublicConfig } from './runtime-config';

loadPublicConfig()
  .then(async () => {
    const [{ appConfig }, { AppComponent }] = await Promise.all([
      import('./app/app.config'),
      import('./app/app.component'),
    ]);
    return bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [provideZoneChangeDetection(), ...appConfig.providers],
    });
  })
  .catch(() => console.error('Application startup failed'));
